import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "icon-wrapper" }


import {
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonIcon,
} from "@ionic/vue";
import AppButton from "@/components/Common/AppButton/AppButton.vue";
import ContentCardSkeleton from "@/components/Skeletons/ContentCardSkeleton/ContentCardSkeleton.vue";
import type { Button } from "@/components/Common/AppButton/AppButton.vue";
interface Props {
  id: string;
  title: string;
  icon: string;
  description: string;
  buttonText: string;
  buttonType: Button;
  isLoading: boolean;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ContentCard',
  props: {
    id: {},
    title: {},
    icon: {},
    description: {},
    buttonText: {},
    buttonType: {},
    isLoading: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_ctx.isLoading)
    ? (_openBlock(), _createBlock(ContentCardSkeleton, {
        key: 0,
        "data-test": "card-skeleton"
      }))
    : (_openBlock(), _createBlock(_unref(IonCard), {
        key: 1,
        href: "",
        button: true,
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('card-clicked', _ctx.id)), ["prevent"])),
        "data-test": "section-card"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonCardHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonCardTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(_ctx.title)), 1)
                ]),
                _: 1
              }),
              _createElementVNode("span", _hoisted_1, [
                _createVNode(_unref(IonIcon), {
                  icon: _ctx.icon,
                  "data-test": "icon",
                  "aria-hidden": "true"
                }, null, 8, ["icon"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_unref(IonCardContent), null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t(_ctx.description)), 1)
            ]),
            _: 1
          }),
          (_ctx.buttonText)
            ? (_openBlock(), _createBlock(AppButton, {
                key: 0,
                class: "button",
                size: "small",
                type: _ctx.buttonType,
                label: _ctx.$t(_ctx.buttonText),
                "aria-hidden": "true",
                disabled: false,
                "data-test": "button",
                tabindex: "-1"
              }, null, 8, ["type", "label"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
}
}

})